export default {
  // Navigation
  nav_home: 'Home',
  nav_about: 'About',
  nav_profile: 'Company Profile',
  nav_business: 'Business',
  nav_contact: 'Contact',

  // Language Switcher
  lang_en: 'English',
  lang_ja: '日本語',
  lang_km: 'ខ្មែរ',

  // Hero
  hero_line1: 'Connecting Cambodia and Japan',
  hero_line2: 'through trust, business, and value.',
  hero_desc: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. is a Cambodia-based international company jointly established with Japanese partners. We deliver reliable business solutions across multiple industries, bridging the best of both worlds.',

  // About
  about_label: 'ABOUT US',
  about_title: 'A Bridge Between Cambodia and Japan',
  about_desc: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. was established in Cambodia through a collaborative partnership with respected Japanese companies. As an international subsidiary, we operate with a clean, reliable business structure and serve as a trusted connection point for cross-border business between Cambodia and Japan. Our commitment to professionalism, transparency, and excellence drives everything we do.',

  // Company Profile
  profile_label: 'COMPANY PROFILE',
  profile_company: 'Company Name',
  profile_address: 'Address',
  profile_phone: 'Phone',
  profile_email: 'Email',
  profile_related: 'Related Japanese Companies',

  // Partnership
  partner_label: 'JAPANESE PARTNERSHIP',
  partner_title: 'Built on Trust',
  partner_subtitle: 'Japan-Cambodia Collaboration',
  partner_desc: 'Our company was jointly established by Japanese enterprises with deep expertise in their respective fields. This partnership brings together Japanese precision, quality standards, and business philosophy with Cambodia\'s dynamic market and growth potential. Together, we create lasting value for our partners and clients.',
  partner_1: 'LAV CO., LTD.',
  partner_2: 'IDO Corporation',
  partner_3: 'SWEEP Fukuoka',

  // Business
  business_label: 'OUR BUSINESS',
  business_desc: 'We operate across a wide range of business sectors, delivering value through professional service and international standards.',

  business_1_en: 'Restaurants and late-night food and beverage establishments',
  business_1_ja: 'レストランおよび深夜営業の飲食店',
  business_1_km: 'ភោជនីយដ្ឋាន និង​កន្លែង​លក់​អាហារ និង​ភេសជ្ជៈ​សម្រាប់​ពេល​យប់​ជ្រៅ',

  business_2_en: 'Wholesale and retail of various goods',
  business_2_ja: '各種商品の卸売・小売',
  business_2_km: 'លក់ដុំ និងលក់រាយទំនិញជាច្រើនប្រភេទ',

  business_3_en: 'General construction work; Contracting and agency for various construction works',
  business_3_ja: '一般建設工事、各種建設工事の請負及び代理',
  business_3_km: 'ការងារសំណង់ទូទៅ; ការចុះកិច្ចសន្យា និងភ្នាក់ងារសម្រាប់ការងារសំណង់ផ្សេងៗ',

  business_4_en: 'Cleaning, maintenance, and management of buildings',
  business_4_ja: '建物の清掃、保守、管理',
  business_4_km: 'ការសម្អាត ការថែទាំ និង ការគ្រប់គ្រងអគារ',

  business_5_en: 'Collection and transportation of industrial waste',
  business_5_ja: '産業廃棄物の収集・運搬',
  business_5_km: 'ការប្រមូល និងដឹកជញ្ជូនកាកសំណល់ឧស្សាហកម្ម',

  business_6_en: 'Human resources provision',
  business_6_ja: '人材提供',
  business_6_km: 'ការផ្គត់ផ្គង់ធនធានមនុស្ស',

  business_7_en: 'E-commerce and online information services',
  business_7_ja: '電子商取引およびオンライン情報サービス',
  business_7_km: 'សេវាកម្មព័ត៌មានអនឡាញ និងពាណិជ្ជកម្មអេឡិចត្រូនិក',

  // Strengths
  strengths_label: 'WHY CHOOSE US',
  strengths_title: 'Our Strengths',
  strength_1_title: 'International Collaboration',
  strength_1_desc: 'Jointly established by Japanese companies, we bring international standards and cross-border expertise to every project.',
  strength_2_title: 'Multi-Business Capability',
  strength_2_desc: 'Our diverse portfolio spans construction, food service, retail, cleaning, waste management, HR, and digital services.',
  strength_3_title: 'Cambodia-Japan Bridge',
  strength_3_desc: 'We serve as a reliable connection point for businesses seeking to operate between Cambodia and Japan.',
  strength_4_title: 'Trustworthy Structure',
  strength_4_desc: 'Clean corporate governance, transparent operations, and a commitment to ethical business practices.',
  strength_5_title: 'Flexible Support',
  strength_5_desc: 'We adapt our services to meet the unique needs of clients across different industries and scales.',

  // Contact
  contact_label: 'GET IN TOUCH',
  contact_title: 'Contact Us',
  contact_desc: 'We welcome inquiries and partnerships. Please reach out to us for any business discussions or collaborations.',
  contact_email_label: 'Email',
  contact_phone_label: 'Phone',
  contact_guidance: 'For inquiries, please contact us via email. We aim to respond within 2 business days.',

  // Footer
  footer_company: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD.',
  footer_tagline: 'Connecting Cambodia and Japan through trust and value.',
  partner_1_url: 'http://www.lavgroup.biz/',
  partner_2_url: 'https://ido-corp.jp/',
  partner_3_url: 'https://sweep-sue.com/',

  // Footer
  footer_links: 'Quick Links',
  footer_contact: 'Contact Info',
  footer_location: 'Location',
  footer_copyright: '© 2025 LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
};